import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import DataTable, { MUIDataTableOptions } from "mui-datatables";
import * as DatiFide from "../../../DatiFide";
import * as Glob from "../../../Globale";
import { _TableLoader } from "..";
import { GetExposureLimitsListColumns } from "./ExposureLimitsListColumns";

const useStyles = makeStyles(({ spacing }: Theme) => ({
    tableWrapper: {
        marginTop: spacing(4),
        position: "relative"
    }
}));

interface IExposureLimitsListTableProps {
    Data: DatiFide.CRisAPITipi_FideAffidamento | undefined;
    Options: MUIDataTableOptions;
    IsLoading: boolean;
}

export const _ExposureLimitsListTable: React.FC<IExposureLimitsListTableProps> = React.memo(({ Data, Options, IsLoading }) => {
    const classes = useStyles();

    const GetBinderVal = (listaBinder: Glob.DatiJSON): string => {
        const binderList: number[] = JSON.parse(listaBinder);

        return binderList
            .filter(ID_Binder => Data?.Tipi["ListaBinder"][ID_Binder] != null)
            .map(ID_Binder => Data?.Tipi["ListaBinder"][ID_Binder].Valore)
            .join(", ");
    };

    return (
        <Box className={classes.tableWrapper}>
            {IsLoading && <_TableLoader />}
            <DataTable title="" data={Data?.Dati || []} columns={GetExposureLimitsListColumns(GetBinderVal)} options={Options} />
        </Box>
    );
});



// WEBPACK FOOTER //
// ./src/inar2/components/ExposureLimitsList/ExposureLimitsListTable.tsx